export default {
  todasUnidades: [],
  minhasUnidades: [],
  loading: false,
}
